// CHEAT SHEET: https://gist.github.com/mrmartineau/a4b7dfc22dc8312f521b42bb3c9a7c1e
import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';
import AdvancedController from "./advanced-controller"

export default class InfographicAsSliderController extends AdvancedController {

  static targets = [
    // TODO: use or remove
    // "exampleTarget",
    "slider",
    "navItem",
    "player"
  ];

  static values = {
    // TODO: use or remove
    // exampleString: String,
    // exampleDefault: { type: Number, default: 42 },
    index: { type: Number, default: 0 }
  }

  connect() {
    super.connect(...arguments)
    // TODO: use or remove
    // initialize the swiper
    this.swiper = new Swiper(this.sliderTarget, {
      modules: [Autoplay, EffectFade],
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 1000,
      autoplay: {
        delay: 6000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false,
      },
      // direction: 'vertical',
      // grabCursor: true,
      on: {
        activeIndexChange: () => this.activeIndexChange()
      }
    })

    this.navItemTargets[this.swiper.activeIndex].classList.add('-active')
  }

  onNavClick(e) {
    e.preventDefault();
    this.swiper.slideTo(e.params.slideIndex, 1000)
  }

  activeIndexChange() {
    for (const navItemTarget of this.navItemTargets) {
      navItemTarget.classList.remove('-active')

    }

    for (let i = 0; i < this.swiper.slides.length; i++) {
      if (this.swiper.activeIndex == 0) {
        for (const navItemTarget of this.navItemTargets) {
          navItemTarget.classList.remove('-prev');
        }
      } else if (i > 0) {
        this.navItemTargets[i - 1].classList.add('-prev');
      }
    }
    const player = this.playerTargets[this.swiper.activeIndex];
    player.seek(0);
    player.play();
    this.navItemTargets[this.swiper.activeIndex].classList.add('-active')
  }

}
